import React from 'react'
import './theme_builder.scss';
import { __ } from '@wordpress/i18n';
var plugin_url = nxtext_ajax_object.nxtex_url;

const thmbuilderData = [
    {
        key: 'nxt_theme_builder_card',
        name: __('Advanced Header Builder', 'nexter-extension'),
        desc: __('Get rid of the limited Header customizer. Use Elementor Widgets or Blocks to create custom. menu.', 'nexter-extension'),
        img: plugin_url + 'assets/images/header-builder-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Advanced Footer Builder', 'nexter-extension'),
        desc: __('Your custom Footer with no limit of layout. Create any footer layout you want with our Footer Builder.', 'nexter-extension'),
        img: plugin_url + 'assets/images/footer-builder-img.png',

    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Breadcrumbs Bar', 'nexter-extension'),
        desc: __("Help users navigate your website by adding breadcrumb bar that shows the path they've taken.", 'nexter-extension'),
        img: plugin_url + 'assets/images/breadcrumbs-bar-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('404 Page', 'nexter-extension'),
        desc: __('Turn a "Page Not Found" into an opportunity by customizing your 404 error page with your branding and helpful content.', 'nexter-extension'),
        img: plugin_url + 'assets/images/404-page-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Single Pages', 'nexter-extension'),
        desc: __('Create custom Single pages for your CPT, Blog Posts, or WooCommerce Product Pages.', 'nexter-extension'),
        img: plugin_url + 'assets/images/single-page-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Archive Pages', 'nexter-extension'),
        desc: __('Create custom listing pages for posts, CPT or WooCommerce Products.', 'nexter-extension'),
        img: plugin_url + 'assets/images/archive-page-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Code Snippets', 'nexter-extension'),
        desc: __('Get rid of the limited Header customizer. Use WordPress Blocks or Blocks to create custom menu.', 'nexter-extension'),
        img: plugin_url + 'assets/images/code-snippet-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Display Rules for Theme Builder Sections', 'nexter-extension'),
        desc: __('Control where and how your theme builder sections appear on your site.', 'nexter-extension'),
        img: plugin_url + 'assets/images/display-rules-img.png',
    },
    {
        key: 'nxt_theme_builder_card',
        name: __('Action & Filter Hooks', 'nexter-extension'),
        desc: __("Fine-tune your website's behavior and appearance by utilizing action and filter hooks for developers to extend functionalities.", 'nexter-extension'),
        img: plugin_url + 'assets/images/actions-filter-hooks-img.png',
    },

];

const ThemeBuilder = () => {
    return (
        <div className='nxt_theme_builder_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Theme Builder', 'nexter-extension')}</h3>

                <div className='nxtext_head_tgl_btn_grp'>
                    <a href='edit.php?post_type=nxt_builder' target="_blank" rel="noopener noreferrer" className='nxtext_blue_common_btn'>{ __('Open Theme Builder' , 'nexter-extension') }</a>
                </div>
            </div>

            <div className='nxt_theme_builder_box_cover_main'>
                <h3 className='nxtext_secondary_heading'>{ __('Get Theme Builder for WordPress with our Nexter Extension' , 'nexter-extension') }</h3>

                <div className='nxt_theme_builder_grid_view_box'>
                    {
                        thmbuilderData.map((obj) => (
                            <div className='nxt_theme_builder_box' key={obj.key}>

                                <div className='nxt_theme_builder_cover_img_box'>
                                    <img className='nxt_theme_builder_img' src={obj.img} draggable={false} />
                                </div>
                                <div className='nxt_theme_builder_description'>
                                    <h4 className='nxt_theme_builder_title nxtext_secondary_heading'>{obj.name}</h4>
                                    <p className='nxt_tb_card_desc'>{obj.desc}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className='nxt_view_all_btm_btn'>
                    <a href={'https://nexterwp.com/nexter-extension/?utm_source=wpbackend&utm_medium=banner&utm_campaign=nextersettings'} target="_blank" rel="noopener noreferrer" className='nxtext_primary_btn'>{ __('Learn More' , 'nexter-extension') }</a>
                </div>
            </div>
        </div>
    )
}

export default ThemeBuilder;